///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.item_setup_complete_notify = abcsetup.item_setup_complete_notify || {};
abcsetup.item_setup_complete_notify.index = abcsetup.item_setup_complete_notify.index || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.item_setup_complete_notify.index = {
    init: function() {
        abcsetup.setTitle('Setup Complete Notifications');

        var item_setup_complete_notify = JSON.parse(String($('form.item_setup_complete_notify #item_setup_complete_notify_object').text()));
        console.log('item_setup_complete_notify', item_setup_complete_notify)
        abcsetup.form_manager.form = $('form.item_setup_complete_notify');

        for (var i in item_setup_complete_notify) {
            for (var type in item_setup_complete_notify[i]) {
                for (var division in item_setup_complete_notify[i][type]) {
                    if (division === null || division == '') {
                        division_type = 'all';
                    }
                    else {
                        division_type = division;
                    }

                    if (i == 'front_store_item' || i == 'rx_item') {
                        if (type) {
                            var email_field = 'fields['+i+']['+type+']['+division_type+']'+'[email_to]';
                            var user_field =  'fields['+i+']['+type+']['+division_type+']'+'[user]';
                            var new_product_launch_field = 'fields['+i+']['+type+']['+division_type+']'+'[new_product_launch]';
                        } else {
                            var email_field = 'fields['+i+'][NULL]['+division_type+']'+'[email_to]';
                            var user_field =  'fields['+i+'][NULL]['+division_type+']'+'[user]';
                            var new_product_launch_field = 'fields['+i+'][NULL]['+division_type+']'+'[new_product_launch]';
                        }
                    }
                    else {
                        var email_field = 'fields['+i+'][NULL][email_to]';
                        var user_field =  'fields['+i+'][NULL][user]';
                    }

                    var email_to = '';
                    var user = '';
                    var new_product_launch = '';
                    if (item_setup_complete_notify[i][type][division]['email_to'] !== undefined && item_setup_complete_notify[i][type][division]['email_to'] !== null) {
                        var email_to = item_setup_complete_notify[i][type][division]['email_to'];
                    }

                    if (item_setup_complete_notify[i][type][division]['user'] !== undefined && item_setup_complete_notify[i][type][division]['user'] !== null) {
                        user = item_setup_complete_notify[i][type][division]['user'];
                    }

                    if (item_setup_complete_notify[i][type][division]['new_product_launch'] !== undefined && item_setup_complete_notify[i][type][division]['new_product_launch'] !== null) {
                        new_product_launch = item_setup_complete_notify[i][type][division]['new_product_launch'];
                    }

                    abcsetup.form_manager._setFieldValue(email_field,email_to.toString());
                    abcsetup.form_manager._setFieldValue(user_field,user);
                    abcsetup.form_manager._setFieldValue(new_product_launch_field,new_product_launch.toString());
                }
            }
        };
    },
}